import { NavItemsService } from "@/common/api.service";
import { FETCH_NAVIGATION, NAVIGATION_EDIT } from "./actions.type";
import { SET_NAVIGATION } from "./mutations.type";

const state = {
  errors: {},
  navItems: {}
};

const getters = {
  navigation(state) {
    return state.navItems;
  }
};

const actions = {
  async [FETCH_NAVIGATION](context) {
    const { data } = await NavItemsService.get();

    // add 'id' to returned object - property used by cms but not saved in database
    if (data !== null) {
      let modifiedData = data

      modifiedData.categories.forEach((category, index) => {
        category['id'] = category['_id']
  
        category.children.forEach((baseItem, index) => {
          baseItem['id'] = baseItem['_id']
  
          baseItem.children.forEach((childItem, index) => {
            childItem['id'] = childItem['_id']
          })
        })
      })

      context.commit(SET_NAVIGATION, modifiedData);
      return modifiedData;
    } else {
      
      // return skeleton navigation object
      const navItems = {
        categories: []
      }

      context.commit(SET_NAVIGATION, navItems);
      return data;
    }
  },
  
  [NAVIGATION_EDIT](context, navigation) {
    return NavItemsService.update(navigation);
  }
};

const mutations = {
  [SET_NAVIGATION](state, user) {
    state.navItems = user;
    state.errors = {};
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
